import React from "react";
import OAuthCallbackShell from "./OAuthCallbackShell";

const buildPayload = (params) => ({
  code:  params.get("code")  || "",
  state: params.get("state") || "",
});

const TikTokAdsCallback = () => (
  <OAuthCallbackShell
    platform="TikTok Ads"
    endpoint="/api/ads-auth/tiktok/callback"
    buildPayload={buildPayload}
  />
);

export default TikTokAdsCallback;
